module.exports = __webpack_public_path__ + "static/services-hero-f10d89f5ce81b42bdc61759622f63086.svg";